import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const StyledSection = styled.section`
  max-width: 1260px;
  margin: 0 auto;
  padding: 0 clamp(28px, 6vw, 80px) 120px;

  .grid {
    display: grid;
    grid-template-columns: 0.9fr 1.1fr;
    gap: 36px;
    align-items: start;

    @media (max-width: 980px) {
      grid-template-columns: 1fr;
    }
  }

  .eyebrow {
    margin: 0 0 10px;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.16em;
  }

  .title {
    margin: 0 0 18px;
    color: var(--text-primary);
    font-size: clamp(34px, 4.6vw, 54px);
    line-height: 1.06;
    letter-spacing: -0.045em;
    max-width: 520px;
  }

  .left p {
    max-width: 560px;
    color: var(--text-secondary);
    font-size: 18px;
    line-height: 1.9;
  }

  .card {
    padding: 30px;
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.44);
    border: 1px solid rgba(255, 255, 255, 0.55);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow:
      0 12px 34px rgba(0, 0, 0, 0.045),
      inset 0 1px 0 rgba(255, 255, 255, 0.36);
  }

  .role {
    margin: 0 0 8px;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.12em;
  }

  .company {
    margin: 0 0 18px;
    color: var(--text-primary);
    font-size: clamp(28px, 3vw, 38px);
    line-height: 1.08;
    letter-spacing: -0.03em;
  }

  .summary {
    color: var(--text-secondary);
    font-size: 16px;
    line-height: 1.85;
    margin-bottom: 24px;
  }

  .bullets {
    display: grid;
    gap: 14px;
  }

  .bullet {
    color: var(--text-secondary);
    font-size: 15px;
    line-height: 1.8;
    padding-left: 18px;
    position: relative;
  }

  .bullet:before {
    content: "";
    position: absolute;
    top: 11px;
    left: 0;
    width: 6px;
    height: 6px;
    border-radius: 999px;
    background: #111111;
    opacity: 0.75;
  }

  .link {
    display: inline-block;
    margin-top: 24px;
    color: var(--text-primary);
    text-decoration: none;
    font-family: var(--font-mono);
    font-size: 13px;
    border-bottom: 1px solid var(--border-medium);
    padding-bottom: 4px;
    transition: var(--transition);
  }

  .link:hover {
    opacity: 0.7;
  }
`;

const ExperienceProof = () => {
  return (
    <StyledSection>
      <div className="grid">
        <div className="left">
          <p className="eyebrow">Experience</p>
          <h2 className="title">Built in real environments, not only side projects.</h2>
          <p>
            My work spans legal analytics, property, finance, software delivery, and
            technical problem-solving across messy operational datasets. I build systems
            that are structured, defensible, and usable in real decision-making contexts.
          </p>
        </div>

        <div className="card">
          <p className="role">Professional Snapshot</p>
          <h3 className="company">From analytics to production-minded delivery</h3>

          <p className="summary">
            Across different roles and domains, I have worked on reporting systems,
            forecasting workflows, compliance analytics, dashboards, automation, and
            machine-learning-oriented problem solving with a focus on clarity and outcomes.
          </p>

          <div className="bullets">
            <div className="bullet">
              Worked across legal, property, finance, operational, and analytical environments.
            </div>
            <div className="bullet">
              Built Python, SQL, reporting, dashboard, and workflow automation solutions.
            </div>
            <div className="bullet">
              Comfortable translating ambiguous business problems into structured technical systems.
            </div>
          </div>

          <Link className="link" to="/experience">
            See full experience
          </Link>
        </div>
      </div>
    </StyledSection>
  );
};

export default ExperienceProof;